import config from 'services/table/const';
import { currencyFormat, formatDate } from 'utilities/common';

let table = { ...config };
table.url = '/wms/stock/log';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    alias: 'item.code',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="fs-8 fw-semibold">{row?.item?.code}</div>
          <small className="info text-uppercase text-ellipsis">
            {row?.item?.barcode ? `Barcode: ${row?.item?.barcode}` : null}
          </small>
        </div>
      );
    },
  },

  name: {
    title: 'Name',
    sortable: true,
    alias: 'item.code',
    width: 150,
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.item?.alias_name}
        </div>
      );
    },
  },

  ref_code: {
    title: 'Ref Kode',
    class: 'text-start',
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="fs-8 fw-semibold">{row?.ref_code}</div>
          <small className="info text-uppercase text-ellipsis">
            {`tipe: ${row?.ref_type?.replaceAll('_', ' ')}`}
          </small>
        </div>
      );
    },
  },

  quantity: {
    title: 'Quantity',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 70,
    component: (row) => {
      return <div>{currencyFormat(row?.quantity)} {row?.item?.default_fraction}</div>;
    },
  },

  recorded_at: {
    title: 'Tanggal Tercatat',
    class: 'text-start',
    width: 100,
    component: (row) => {
      return (
        <div className="text-ellipsis">{formatDate(row?.recorded_at, 'DD/MM/YYYY hh:mm')}</div>
      );
    },
  },
};
export default table;
